import { z } from "zod";
import { FIRST_NAME, LAST_NAME, SEARCH_CRITERIA, SEARCH_TYPE } from "./consts";

export const schema = z.object({
  [SEARCH_TYPE]: z.string().optional(),
  [FIRST_NAME]: z.string().optional(),
  [LAST_NAME]: z.string().optional(),
  [SEARCH_CRITERIA]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
